import React, { useEffect, useState } from 'react'
import classes from "../UserDetails/style.module.scss";
import { Images } from '../../../../assets';
import moment from 'moment';
import { ContactOption, YESOrNoOption } from '../../../../helpers';

const PersonalInformation = (props) => {
    const { documents, facilityPhotos, businessInfo, contactInfo, companyInfo } = props

    const AADHAR_CARD = 'aadhaar_card'
    const GST_CERTIFICATE = 'gst_certificate'
    const TRADE_LICENSE = 'trade_license'
    const FACILITY_PHOTOS = 'facility_photos'
    const EMIRATES_ID = 'emirates_id'
    const IQAMA = 'iqama'

    const [documentList, setDocumentList] = useState({})

    useEffect(() => {
        const nonEmptyValues = getNonEmptyValues(documents?.concat(facilityPhotos));
        setDocumentList(nonEmptyValues)
    }, [documents, facilityPhotos])

    const getNonEmptyValues = (documents) => {
        return documents?.reduce((result, obj) => {
            for (const key in obj) {
                if (obj.hasOwnProperty(key) && obj[key]) {
                    result[key] = obj[key];
                }
            }
            return result;
        }, {});
    }
    const getDocIcon = (fileUrl) => {
        if (!fileUrl) return null;
        const extension = fileUrl.split('.').pop().toLowerCase();
        if (extension === 'pdf') {
            return Images.pdfFormat;
        } else if (extension === 'doc' || extension === 'docx') {
            return Images.docFormat;
        } else {
            return Images.defaultIcon;
        }
    };

    return (
        <>
            <div className={`${classes.userCardWrapper} mb-4`}>
                <div className={`${classes.informationTitle}`}>
                    Profile details
                </div>
                {documentList && Object.keys(documentList)?.length > 0 ?
                    <div className={`${classes.detailsWrapper}`}>
                        <div className={`${classes.infoWrapper}`}>
                            {documentList?.[AADHAR_CARD] ?
                                <div className={`${classes.inforCategory}`}>
                                    <div className='mb-1'>
                                        <div className={`${classes.infoLabel}`}>Aadhar Card</div>
                                        <div className={`${classes.infoValue}`}>{documentList?.[AADHAR_CARD] || '-'}</div>
                                    </div>
                                </div> : null}
                            {documentList?.[EMIRATES_ID] ?
                                <div className={`${classes.inforCategory}`}>
                                    <div className='mb-1'>
                                        <div className={`${classes.infoLabel}`}>EMIRATES ID</div>
                                        <div className={`${classes.infoValue}`}>{documentList?.[EMIRATES_ID] || '-'}</div>
                                    </div>
                                </div> : null}
                            {documentList?.[IQAMA] ?
                                <div className={`${classes.inforCategory}`}>
                                    <a href={documentList?.[IQAMA]} target='blank' className='flex items-center mb-1'>
                                        <img src={getDocIcon(documentList?.[IQAMA])} className={classes.formatImageLogo} alt='PDF File' />
                                        <div className={`${classes.infoValue} pl-3`}>IQAMA Certificate</div>
                                    </a>
                                </div> : null}
                            {documentList?.[GST_CERTIFICATE] ?
                                <div className={`${classes.inforCategory}`}>
                                    <a href={documentList?.[GST_CERTIFICATE]} target='blank' className='flex items-center mb-1'>
                                        <img src={getDocIcon(documentList?.[GST_CERTIFICATE])} className={classes.formatImageLogo} alt='PDF File' />
                                        <div className={`${classes.infoValue} pl-3`}>GST Certificate</div>
                                    </a>
                                </div> : null}
                            {documentList?.[TRADE_LICENSE] ?
                                <div className={`${classes.inforCategory}`}>
                                    <a href={documentList?.[TRADE_LICENSE]} target='blank' className='flex items-center mb-1'>
                                        <img src={getDocIcon(documentList?.[TRADE_LICENSE])} className={classes.formatImageLogo} alt='PDF File' />
                                        <div className={`${classes.infoValue} pl-3`}>Trade license</div>
                                    </a>
                                </div> : null}
                        </div>
                        {documents ?
                            <div className={`${classes.infoWrapper} mt-3`}>
                                {documents.map((photo, index) => (
                                    <div className={`${classes.inforCategory}`}>
                                        <a href={photo} target='blank' className='flex items-center mb-1' key={index}>
                                            <img src={Images.pdfFormat} className={classes.formatImageLogo} alt={`Document ${index + 1}`} />
                                            <div className={`${classes.infoValue} pl-3`}>Document {index + 1}</div>
                                        </a>
                                    </div>
                                ))}
                            </div>
                            : null}
                        {facilityPhotos ?
                            <div className={`${classes.infoWrapper} mt-3`}>
                                {facilityPhotos.map((photo, index) => (
                                    <div className={`${classes.inforCategory}`}>
                                        <a href={photo} target='blank' className='flex items-center mb-1' key={index}>
                                            <img src={Images.imageFormat} className={classes.formatImageLogo} alt={`Facility Photo ${index + 1}`} />
                                            <div className={`${classes.infoValue} pl-3`}>Facility photo {index + 1}</div>
                                        </a>
                                    </div>
                                ))}
                            </div>
                            : null}
                    </div> : null
                }
                <div className={`${classes.detailsWrapper}`}>
                    <div className={`${classes.informationHeader}`}>
                        Business information
                    </div>
                    <div className={`${classes.infoWrapper}`}>
                        <div className={`${classes.inforCategory}`}>
                            <div className={`${classes.infoLabel}`}>Legal name of the business</div>
                            <div className={`${classes.infoValue}`}>{businessInfo?.legal_name || '-'}</div>
                        </div>
                        <div className={`${classes.inforCategory}`}>
                            <div className={`${classes.infoLabel}`}>Phone Number</div>
                            <div className={`${classes.infoValue}`}>{companyInfo?.owner_mobile_number || businessInfo?.mobile_number || '-'}</div>
                        </div>
                        <div className={`${classes.inforCategory}`}>
                            <div className={`${classes.infoLabel}`}>Website URL</div>
                            <div className={`${classes.infoValue}`}>{businessInfo?.website_url || '-'}</div>
                        </div>
                        <div className={`${classes.inforCategory}`}>
                            <div className={`${classes.infoLabel}`}>Company Email</div>
                            <div className={`${classes.infoValue}`}>{companyInfo?.owner_email || businessInfo?.email || '-'}</div>
                        </div>
                        <div className={`${classes.inforCategory}`}>
                            <div className={`${classes.infoLabel}`}>Company Address</div>
                            <div className={`${classes.infoValue}`}>{companyInfo?.company_address || businessInfo?.business_address || '-'}</div>
                        </div>
                        {/* <div className={`${classes.inforCategory}`}>
                            <div className={`${classes.infoLabel}`}>Business registration number</div>
                            <div className={`${classes.infoValue}`}>{businessInfo?.business_reg_no || '-'}</div>
                        </div>
                        <div className={`${classes.inforCategory}`}>
                            <div className={`${classes.infoLabel}`}>Date of establishment</div>
                            <div className={`${classes.infoValue}`}>{businessInfo?.date_of_establishment ? moment(businessInfo?.date_of_establishment)?.format('DD MMM YYYY') : '-'}</div>
                        </div>
                        <div className={`${classes.inforCategory}`}>
                            <div className={`${classes.infoLabel}`}>Type of business structure</div>
                            <div className={`${classes.infoValue}`}>{businessInfo?.type_of_business_structure || '-'}</div>
                        </div> */}
                    </div>
                </div>
                <div className={`${classes.detailsWrapper}`}>
                    <div className={`${classes.informationHeader}`}>
                        Contact  information
                    </div>
                    <div className={`${classes.infoWrapper}`}>
                        {/* <div className={`${classes.inforCategory}`}>
                            <div className={`${classes.infoLabel}`}>Business address</div>
                            <div className={`${classes.infoValue}`}>{contactInfo?.business_address || '-'}</div>
                        </div> */}
                        <div className={`${classes.inforCategory}`}>
                            <div className={`${classes.infoLabel}`}>Mailing address</div>
                            <div className={`${classes.infoValue}`}>{contactInfo?.mailing_address || '-'}</div>
                        </div>
                        {contactInfo?.contact_method &&
                            <div className={`${classes.inforCategory}`}>
                                <div className={`${classes.infoLabel}`}>Preferred Contact Method</div>
                                <div className={`${classes.infoValue}`}>{ContactOption[contactInfo?.contact_method] || '-'}</div>
                            </div>
                        }
                        {contactInfo?.store_owner &&
                            <div className={`${classes.inforCategory}`}>
                                <div className={`${classes.infoLabel}`}>Store Owner</div>
                                <div className={`${classes.infoValue}`}>{YESOrNoOption[contactInfo?.store_owner] || '-'}</div>
                            </div>
                        }
                        {/* <div className={`${classes.inforCategory}`}>
                            <div className={`${classes.infoLabel}`}>Mobile number</div>
                            <div className={`${classes.infoValue}`}>{contactInfo?.mobile_number || '-'}</div>
                        </div>
                        <div className={`${classes.inforCategory}`}>
                            <div className={`${classes.infoLabel}`}>Email</div>
                            <div className={`${classes.infoValue}`}>{contactInfo?.email || '-'}</div>
                        </div>
                        <div className={`${classes.inforCategory}`}>
                            <div className={`${classes.infoLabel}`}>Website URL</div>
                            <div className={`${classes.infoValue}`}>{contactInfo?.website_url || '-'}</div>
                        </div> */}
                    </div>
                </div>
            </div>
        </>
    )
}

export default PersonalInformation